module.exports = __webpack_public_path__ + "img/aibg.5ef4e65c.png";